/**
 * IONLOOP — product screenshot loading.
 *
 * Screenshots are supplied manually as local files. Until a file exists the
 * container keeps its development placeholder (no broken-image icon, no layout
 * shift). When the file is added it fades in automatically.
 *
 * Optional mobile variants are applied only if the mobile asset exists; the
 * desktop image remains the fallback.
 */

(function () {
    'use strict';

    var SHOT_SELECTOR = '[data-screenshot]';
    var IMG_SELECTOR = '.ili-about-eco__shot-img';
    var SOURCE_SELECTOR = '.ili-about-eco__shot-source';
    var MOBILE_QUERY = '(max-width: 767.98px)';

    function setup(shot) {
        var img = shot.querySelector(IMG_SELECTOR);
        if (!img) {
            return;
        }

        function markLoaded() {
            shot.classList.add('is-loaded');
            shot.classList.remove('is-missing');
        }

        function markMissing() {
            shot.classList.add('is-missing');
            shot.classList.remove('is-loaded');
        }

        img.addEventListener('load', markLoaded);
        img.addEventListener('error', markMissing);

        if (img.complete) {
            if (img.naturalWidth > 0) {
                markLoaded();
            } else {
                markMissing();
            }
        }

        var source = shot.querySelector(SOURCE_SELECTOR);
        if (source && window.matchMedia(MOBILE_QUERY).matches) {
            var candidate = source.getAttribute('data-srcset');
            if (candidate) {
                var probe = new Image();
                probe.onload = function () {
                    source.setAttribute('srcset', candidate);
                    source.removeAttribute('data-srcset');
                };
                probe.onerror = function () {
                    source.parentNode.removeChild(source);
                };
                probe.src = candidate;
            }
        }
    }

    function init() {
        var shots = Array.prototype.slice.call(document.querySelectorAll(SHOT_SELECTOR));
        if (!shots.length) {
            return;
        }

        if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        observer.unobserve(entry.target);
                        setup(entry.target);
                    }
                });
            }, { rootMargin: '300px 0px' });
            shots.forEach(function (shot) { observer.observe(shot); });
        } else {
            shots.forEach(setup);
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();
